import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RemovableField } from '@/shared/ui';
import type { ConversationAttributeItem } from '@/entities/attributes/model/api/types';
import { withSecondsSuffix } from '@/entities/attributes';
import { useTimeDisplayFormat } from '@/entities/settings';
import type { AttributeFilter } from '@/entities/dashboards';
import { getAttributeFilterKind } from '../model/attributeFilters';
import { AttributeFilterField } from './AttributeFilterField';

type Props = {
  /** Атрибут из системной конфигурации; может быть undefined для «осиротевшего» фильтра */
  attribute: ConversationAttributeItem | undefined;
  /** Текущее значение фильтра */
  filter: AttributeFilter;
  /** Обновление фильтра */
  onChange: (next: AttributeFilter) => void;
  /** Удаление атрибута из активной панели фильтров */
  onRemove: () => void;
};

/**
 * Ячейка одного атрибутного фильтра. Размещается в сетке фильтров экрана-потребителя.
 * Лейбл — имя атрибута, компонент ввода выбирается по `Attribute.dataType`.
 */
export const AttributeFilterCell: FC<Props> = ({ attribute, filter, onChange, onRemove }) => {
  const { t } = useTranslation('common');
  const timeDisplayFormat = useTimeDisplayFormat();
  const label = withSecondsSuffix(
    attribute?.name || attribute?.pathDescription || filter.path,
    attribute,
    timeDisplayFormat,
    t('secondsSuffix'),
  );
  const kind = getAttributeFilterKind(attribute);

  return (
    <RemovableField label={label} removeLabel={t('attributeFilters.removeAttribute')} onRemove={onRemove}>
      {attribute && kind !== null && <AttributeFilterField attribute={attribute} filter={filter} onChange={onChange} />}
    </RemovableField>
  );
};
